import './AboutUs.css';
import background from "../assets/img/background_about_us.png";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import logo from "../assets/img/logo.png";
import iconRose from "../assets/img/icon_rose.png";
import iconBrown from "../assets/img/icon_brown.png";
import iconSilver from "../assets/img/icon_silver.png";
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';
import {useTheme} from '@material-ui/core/styles';

const VIEWS = {
    about: {
        title: () => (<img src={logo} className="image-logo-title" alt="logo"/>),
        textColor: "#432A19",
        color: "rgba(255, 255, 255, 0.75)",
        text: "Somos un proceso organizativo de mujeres campesinas, con experiencia en trabajo con enfoque de género y Derechos Humanos; nos juntamos hace 20 años para mejorar la calidad de vida de las mujeres, defender el territorio, hacer resistencia al sistema capitalista y construir un buen vivir en las comunidades campesinas. Desde la cotidianidad en la vida del campo y la ruralidad de las mujeres, el trabajo se integra en un modelo comunitario autónomo, fundamentado en los derechos de las mujeres, soberanía alimentaria y economía solidaria y popular."
    },
    mission: {
        title: () => (<div className="image-title">
            <img src={iconRose} className="image" alt="icon"/>
            <div className="button-name">MISIÓN</div>
        </div>),
        textColor: "rgba(255, 255, 255, 0.75)",
        color: "rgba(80, 31, 97, 0.7)",
        text: "Liderar procesos de exigibilidad y movilización social para garantizar un nivel de vida en condiciones de equidad y dignidad para las mujeres del territorio, a través de la superación de la discriminación y las violencias basadas en el género, la promoción de la participación política de las mujeres, el mejoramiento de su calidad de vida y su posicionamiento como sujetas políticas protagónicas en sus comunidades."
    },
    vision: {
        title: () => (<div className="image-title image-title-green">
            <img src={iconBrown} className="image" alt="icon"/>
            <div className="button-name">VISIÓN</div>
        </div>),
        textColor: "rgba(255, 255, 255, 0.75)",
        color: "rgba(67, 145, 41, 0.75)",
        text: "El Comité de Mujeres de la Asociación Campesina de Inzá Tierradentro ACIT, será una organización social, autónoma, política, participativa e incluyente, con un equipo humano de trabajo comprometido con el desarrollo de las mujeres campesinas enmarcado en conceptos de equidad de género, empoderamiento femenino, participación política de las mujeres, soberanía alimentaria y economía solidaria."
    },
    history: {
        title: () => (<div className="image-title image-title-silver">
            <img src={iconSilver} className="image" alt="icon"/>
            <div className="button-name">RESEÑA HISTÓRICA</div>
        </div>),
        textColor: "#432A19",
        color: "rgba(255, 255, 255, 0.75)",
        text: "El comité de mujeres de la Asociación Campesina de Inzá Tierradentro - ACIT, es un colectivo de mujeres con una amplia trayectoria de trabajo político-organizativo, que promueve espacios de representación y el mejoramiento de la calidad de vida y el buen vivir de las mujeres en el municipio de Inzá. Nuestra base social está conformada por mujeres campesinas, proyectamos nuestro futuro, el de nuestras familias y comunidades a partir de nuestras propias formas de organización social y de trabajo colectivo con enfoque de género.        Nacimos en el año 2000 en el marco de las contiendas electorales, con el fin de buscar un espacio de participación política para las mujeres en el ámbito local; inscribiendo una lista de mujeres al concejo, con un aval. Logrando este objetivo se realizó un diagnóstico para conocer las problemáticas de las mujeres, donde encontramos: bajo nivel educativo; falta de espacios de formación y capacitación en temas relacionados con la salud, la producción agropecuaria y la economía familiar; alto índice de violencia intrafamiliar; alto índice de delitos sexuales; desconocimiento del trabajo de las mujeres en todos los espacios; exclusión de los espacios de participación en la familia y en la  comunidad; sobre carga de trabajo; alto índice de embarazos a temprana edad; dificultad para la producción de los alimentos básicos para las familias; altos índices de desnutrición; deficiencia en los programas de promoción de salud y prevención de enfermedades, entre otros,  decidimos  conmemoramos el 8 de marzo del 2001,  para dar a conocer los problemas y las propuestas  encontradas.  A este evento llegaron más de 1500 mujeres. Este fue el punto de partida de un proceso que se ha consolidado a partir de la búsqueda de soluciones y desde la premisa que si las mujeres estamos bien la familia y la comunidad estarán bien.        Nos propusimos trabajar en unas apuestas políticas que dieran solución a los problemas encontrados.          Conscientes de la gravedad de la situación de las mujeres, ese año se dio inicio a un proceso de capacitación en las comunidades indígenas y campesinas del municipio, con algunos recursos gestionados por el comité de mujeres ante la Gobernación del Cauca y aportes de la Asociación de cabildos indígenas Juan Tama y la Asociación campesina de Inzá Tierradentro “ACIT” .        Luego de hacer los acercamientos necesarios y recorrer el territorio, se propuso trabajar en cinco líneas específicas, buscando superar las dificultades con las que viven nuestras familias y comunidades: Fortalecimiento político-organizativo, Derechos humanos con énfasis en derechos de las mujeres,  Empoderamiento femenino, Soberanía alimentaria, Propuestas productivas y de economía solidaria.        "
    }
}

function a11yProps(index, scroll) {
    if (scroll)
        return {
            id: `scrollable-auto-tab-${index}`,
            'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function AboutUs() {

    const [value, setValue] = React.useState(0);
    const refContainer = React.useRef();
    const [widthContainer, setWidthContainer] = React.useState(null);
    const theme = useTheme();

    React.useEffect(() => {
        setWidthContainer(refContainer.current.clientWidth);
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    return (
        <div className="main-container" ref={refContainer}>
            <img src={background} className="image-background" alt="background"/>
            <Header title={"¿Quiénes Somos?"} subtitle={"Nuestros Principios"}/>
            <div className="body-content">
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="primary"
                        variant={widthContainer >= 800 ? "fullWidth" : "scrollable"}
                        scrollButtons="on"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab label="¿Quiénes somos?" style={{
                            backgroundColor: VIEWS.about.color,
                            color: VIEWS.about.textColor
                        }} {...a11yProps(0, widthContainer < 800)} />
                        <Tab label="Misión" style={{
                            backgroundColor: VIEWS.mission.color,
                            color: VIEWS.mission.textColor
                        }} {...a11yProps(1, widthContainer < 800)} />
                        <Tab label="Visión" style={{
                            backgroundColor: VIEWS.vision.color,
                            color: VIEWS.vision.textColor
                        }} {...a11yProps(2, widthContainer < 800)} />
                        <Tab label="Reseña histórica" style={{
                            backgroundColor: VIEWS.history.color,
                            color: VIEWS.history.textColor
                        }} {...a11yProps(3, widthContainer < 800)} />
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <div className="detail-text" style={{
                            backgroundColor: VIEWS.about.color,
                            color: VIEWS.about.textColor,
                            fontSize: widthContainer < 800 ? 15 : 25
                        }}>
                            <div style={{margin: 'auto'}}>
                                {VIEWS.about.text}
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <div className="detail-text" style={{
                            backgroundColor: VIEWS.mission.color,
                            color: VIEWS.mission.textColor,
                            fontSize: widthContainer < 800 ? 15 : 25
                        }}>
                            <div style={{margin: 'auto'}}>{VIEWS.mission.text}</div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={2} dir={theme.direction}>
                        <div className="detail-text" style={{
                            backgroundColor: VIEWS.vision.color,
                            color: VIEWS.vision.textColor,
                            fontSize: widthContainer < 800 ? 15 : 25
                        }}>
                            <div style={{margin: 'auto'}}>{VIEWS.vision.text}</div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={3} dir={theme.direction}>
                        <div className="detail-text" style={{
                            backgroundColor: VIEWS.history.color,
                            color: VIEWS.history.textColor,
                            fontSize: widthContainer < 800 ? 15 : 17,
                            textAlign:'Justify',
                            paddingLeft: 35,
                            paddingRight: 35,
                            paddingTop: 1                            
                        }}>
                            <div style={{margin: 'auto'}}>{VIEWS.history.text}</div>
                        </div>
                    </TabPanel>
                </SwipeableViews>
            </div>
            <Footer/>
        </div>
    );
}

export default AboutUs;
